import React, { Component, Fragment } from "react";
import { HorizontalBar } from "react-chartjs-2";
import { translate } from "react-multi-lang";
import compose from "compose-function";
import { Card } from "reactstrap";
import PropTypes from "prop-types";

const primaryColor = "rgba(137,57,125,0.9)";
const primaryHoverColor = "rgba(137,57,125,0.75)";

class BarChartComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        labels: this.props.alertsData.label,
        datasets: [
          {
            data: this.props.alertsData.data,
            backgroundColor: primaryColor,
            hoverBackgroundColor: primaryHoverColor,
            label: this.props.title,
            fill: false
          }
        ]
      }
    };
  }
  componentDidUpdate(prevProps) {
    if (
      prevProps.alertsData !== this.props.alertsData ||
      prevProps.title !== this.props.title
    ) {
      this.setState({
        data: {
          labels: this.props.alertsData.label,
          datasets: [
            {
              data: this.props.alertsData.data,
              backgroundColor: primaryColor,
              hoverBackgroundColor: primaryHoverColor,
              label: this.props.title,
              fill: false
            }
          ]
        }
      });
    }
  }
  //   componentDidMount() {
  //     const { datasets } = this.refs.chart.chartInstance.data;
  //     console.log(datasets);
  //   }
  render() {
    return (
      <Fragment>
        <Card id="chart" className="p-2">
          <HorizontalBar
            data={this.state.data}
            height={this.state.data.labels.length > 100 ? "800" : "300"}
            options={{
              title: {
                display: true,
                text: `${this.props.subTitle} :${this.props.totalValue}`,
                fontSize: 15,
                fontColor: "#2c2c2c",
                position: "bottom"
              },
              legend: {
                display: true,
                position: "top",
                labels: {
                  fontColor: "#2c2c2c"
                }
              },
              scales: {
                xAxes: [
                  {
                    ticks: {
                      fontColor: "#2c2c2c"
                    },
                    gridLines: {
                      color: "rgba(44,44,44,0.08)"
                    }
                  }
                ],
                yAxes: [
                  {
                    ticks: {
                      fontColor: "#2c2c2c"
                    },
                    gridLines: {
                      color: "rgba(44,44,44,0.08)"
                    }
                  }
                ]
              }
              // scales: {
              //   xAxes: [
              //     {
              //       stacked: true
              //     }
              //   ],
              //   yAxes: [
              //     {
              //       stacked: true
              //     }
              //   ]
              // }
            }}
          />
        </Card>
      </Fragment>
    );
  }
}

BarChartComponent.propTypes = {
  t: PropTypes.func
};

export default compose(translate)(BarChartComponent);
